import axios from 'axios';
import { notification } from 'antd';

export const registerAsCompany = (hash) => (dispatch) => {
  dispatch({
    type: 'REGISTER_COMPANY_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/registerAsCompany',
    method: 'POST',
    data: {
      ...hash
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (!flag) {
      const { message } = data;
      dispatch({
        type: 'REGISTER_COMPANY_FAILED',
        payload: { loading: false }
      });
      return Promise.reject(new Error(message && message.error && message.error.email ? message.error.email : message && message.error ? message.error : ''  ))
    } else {
      const { message } = data;
      notification.success({
        message: 'REGISTER COMPANY',
        description: message.message
      });
      return dispatch({
        type: 'REGISTER_COMPANY_SUCCESS',
        payload: {
          loading: false,
          status: true
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'REGISTER COMPANY',
      description: error.message
    });

    return dispatch({
      type: 'REGISTER_COMPANY_FAILED',
      payload: { loading: false }
    });
  })
}